import { createContext, useContext } from 'react';

/**
 * Copy override for the form-first challenge page (ChallengePageFormFirst).
 *
 * WHY: arm C of the 2026-10-02 A/B/C test is an exact copy of arm B
 * (form_first) with a different heading and subheading. The experiment wrapper
 * provides the override, so C renders B's page, B's layout and the one shared
 * registration form in ChallengePage without a second page component. null
 * (the default) means B's own copy: the catalog's challenge name and B's
 * promise.
 */
export type ChallengeFormFirstCopy = {
  heading: string;
  subheading: string;
} | null;

export const ChallengeFormFirstCopyContext = createContext<ChallengeFormFirstCopy>(null);

export const useChallengeFormFirstCopy = (): ChallengeFormFirstCopy =>
  useContext(ChallengeFormFirstCopyContext);
